import React from 'react';
import { faBuilding } from '@fortawesome/pro-regular-svg-icons';

import PageHeader from 'components/page_header';

import MergeButton from './merge_button';

export function DuplicatesPageHeader() {
  return (
    <PageHeader
      iconDescription="Manage your properties database"
      iconName={faBuilding}
      iconSize="lg"
      iconText="Properties"
      iconType="icon"
    >
      <div className="top-bar">
        <div className="d-inline-block hidden-sm hidden-xs">
          <MergeButton />
        </div>
      </div>
    </PageHeader>
  );
}

export default DuplicatesPageHeader;
